import { ReachAPI } from './ReachAPI';
import { Log } from '../AuxillaryService/Log';

/**
 * @class cdn
 * @hideconstructor
 * @memberof ReachAPI
 */
ReachAPI.cdn = {};

/**
 * GET Endpoint `/cdn/asset/info`
 * @param {string} uuid
 * @throws {jqpFailure}
 * @returns {jqpSuccess}
 * @memberof ReachAPI.cdn
 */
ReachAPI.cdn.getAssetInfo = function (uuid) {
    var cache_id = '/asset/info/uuid=' + uuid;
    var url = ReachAPI.server + '/cdn/asset/info';
    var params = {
        arls: 'asset://uuid=' + uuid,
    };
    var jqPromise;

    jqPromise = ReachAPI.getWithFallback(url, 'json', params, cache_id);

    jqPromise.done(function (data, textStatus) {
        if (textStatus === 'cache') {
            Log.Debug(
                'Retrieved information about asset from the CACHE (API call failed)',
                null,
                __fileline
            );
        } else {
            Log.Debug('Retrieved information about asset from the API', null, __fileline);
        }
    });

    jqPromise.fail(function (jqXHR, textStatus, errorThrown, msg, event) {
        Log.Warning(
            'Failed to retrieve information about asset',
            null,
            __fileline,
            ReachAPI.createPromiseFailObject(jqXHR, textStatus, errorThrown, msg, event)
        );
    });

    return jqPromise;
};
